import { BaseModel } from '@shared/models/entity/base/base.model';

interface IMailbox {
  address: string;

  displayName: string;

  assignedUserId: string | null;

  agentStyleGuide: string;

  agentSignature: string;
  importExcludedSenders: string[];

  syncEnabled: boolean;

  lastSyncedAt: string;

  emailCount: number;
}

export class Mailbox extends BaseModel implements IMailbox {
  importExcludedSenders: string[] = [];

  /**
   * The primary smtp address of the Exchange mailbox.
   */
  address: string;

  /**
   * The display name shown in lists and the email inbox.
   */
  displayName: string;

  assignedUserId: string | null;

  agentStyleGuide: string;

  agentSignature: string;

  /**
   * Whether the delta sync currently includes this mailbox.
   */
  syncEnabled: boolean;

  /**
   * The iso date time of the last completed sync run.
   */
  lastSyncedAt: string;

  /**
   * The number of emails imported from this mailbox.
   */
  emailCount: number;
  constructor(init?: Partial<Mailbox> & { isEnabled?: boolean }) {
    super(init);

    // The api names this field isEnabled — map it HERE at the boundary. The former
    // `??= true` never saw the api value and showed every mailbox as active, while the
    // form's save payload (also misnamed) silently DISABLED the mailbox on every save.
    this.syncEnabled = init?.syncEnabled ?? init?.isEnabled ?? true;
  }

}